export interface IPreviewFrame {
  src: string;
  isFront: boolean;
}

// Double buffering, keyed by the page each frame shows. The page behind the
// preview reloads on every change, and a document being parsed is not
// something anyone should watch: the next configuration loads in a frame of
// its own while what is already on screen stays until that one is whole. A
// configuration that is superseded before it finished loading simply loses its
// frame, so a late load can never promote the wrong page.
export const getPreviewFrames = (
  frontSrc: string | null,
  src: string
): IPreviewFrame[] => [
  ...(frontSrc ? [{ src: frontSrc, isFront: true }] : []),
  ...(frontSrc === src ? [] : [{ src, isFront: false }]),
];
